<template>
  <div id="enterprise">
    <NavigationBar />
    <HeroSectionEnterprise />
    <EnterpriseValueProposition />
    <UsageFlowSection />
    <FeaturesSection />
    <TrustSection />
    <InvestmentSection />
    <EnterpriseCTA />
    <FooterSection />
  </div>
</template>

<script>
import NavigationBar from '@/components/Navigation.vue'
import HeroSectionEnterprise from '@/components/HeroSectionEnterprise.vue'
import EnterpriseValueProposition from '@/components/EnterpriseValueProposition.vue'
import UsageFlowSection from '@/components/UsageFlowSection.vue'
import FeaturesSection from '@/components/FeaturesSection.vue'
import TrustSection from '@/components/TrustSection.vue'
import InvestmentSection from '@/components/InvestmentSection.vue'
import EnterpriseCTA from '@/components/EnterpriseCTA.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'EnterprisePage',
  components: {
    NavigationBar,
    HeroSectionEnterprise,
    EnterpriseValueProposition,
    UsageFlowSection,
    FeaturesSection,
    TrustSection,
    InvestmentSection,
    EnterpriseCTA,
    FooterSection
  }
}
</script>

<style scoped>
#enterprise {
  width: 100%;
}
</style>
